import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4 6C4 4.34315 5.34315 3 7 3H13C16.866 3 20 6.13401 20 10V13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13V11H15C13.3431 11 12 9.65686 12 8V5H7C6.44772 5 6 5.44772 6 6V18C6 18.5523 6.44772 19 7 19H12C12.5523 19 13 19.4477 13 20C13 20.5523 12.5523 21 12 21H7C5.34315 21 4 19.6569 4 18V6ZM14 5.10002V8C14 8.55229 14.4477 9 15 9H17.9C17.5023 7.04087 15.9591 5.4977 14 5.10002ZM17 15C17.5523 15 18 15.4477 18 16V18C18 18.5523 17.5523 19 17 19C16.4477 19 16 18.5523 16 18V16C16 15.4477 16.4477 15 17 15ZM18 20.5C18 19.9477 17.5523 19.5 17 19.5C16.4477 19.5 16 19.9477 16 20.5V21C16 21.5523 16.4477 22 17 22C17.5523 22 18 21.5523 18 21V20.5Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}